// extracted by mini-css-extract-plugin
module.exports = {"block":"loadBlock_block__20UwI","fadeIn":"loadBlock_fadeIn__2PhOy"};